module.exports = __webpack_public_path__ + "img/layers.1872c4db.svg";